import React from 'react';
import CountDown from './components/CountDown'

function App() {
  return (
    <React.Fragment>
    <CountDown/>

    </React.Fragment>
  );
}

export default App;
